import React from 'react';

import { makeStyles } from 'tss-react/mui';
import { Box, ErrorInfo, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import { Control } from 'react-hook-form/dist/types';
import ControlledDatePicker from 'web-library/stories/atom/DatePicker/ControlledDatePicker';

const useStyles = makeStyles()((theme) => ({
  dateContainer: {
    width: '30%',
    marginRight: '5%',
    display: 'inline-block',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    '&:last-child': {
      [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(2),
      },
    },
  },
  label: {
    color: theme.palette.text.secondary,
  },
  dateRangeHelperTextContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
  },
  errMsg: {
    marginTop: '0 !important',
  },
}));

interface IRegistrationSelectDate {
  startDate: any;
  endDate: any;
  isError: boolean;
  cusErrorMsg?: string;
  startDateErr: boolean;
  endDateErr: boolean;
  startDateErrMsg?: string;
  endDateErrMsg?: string;
  control: Control<any>;
  onSetValue: (title: string, value: any) => void;
  onSetStartDate: (_date: any) => void;
  onSetEndDate: (_date: any) => void;
}

const RegistrationSelectDate = ({
  startDate,
  endDate,
  isError,
  cusErrorMsg,
  startDateErr,
  endDateErr,
  startDateErrMsg,
  endDateErrMsg,
  onSetValue,
  onSetStartDate,
  onSetEndDate,
  control,
}: IRegistrationSelectDate) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Box className={classes.dateContainer}>
        <ControlledDatePicker
          control={control}
          label={t('admin->>RegistrationReportDetails.Application Start Date')}
          value={startDate}
          onChange={(date: any) => {
            onSetStartDate(date);
            onSetValue('startDate', date ? date.toString() : '');
          }}
          name="startDate"
          disableFuture
          error={startDateErr}
          helperText={startDateErrMsg}
          inputVariant="filled"
          autoOk
          isRequired
        />
      </Box>
      <Box className={classes.dateContainer}>
        <ControlledDatePicker
          control={control}
          label={t('admin->>RegistrationReportDetails.Application End Date')}
          value={endDate}
          onChange={(date: any) => {
            onSetEndDate(date);
            onSetValue('endDate', date ? date.toString() : '');
          }}
          name="endDate"
          disableFuture
          error={endDateErr}
          helperText={endDateErrMsg}
          inputVariant="filled"
          autoOk
          isRequired
        />
      </Box>
      <Box className={classes.dateRangeHelperTextContainer}>
        <Typography className={classes.label} variant="subtitle2">
          {t('admin->>PaymentReport.DateRangeMonths', { noOfMonths: 3 })}
        </Typography>
      </Box>

      {isError && <ErrorInfo className={classes.errMsg} label={cusErrorMsg} />}
    </>
  );
};

export default RegistrationSelectDate;
